import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'

import List from './List'
import ListItem from './ListItem'
import Link from './Link'

import styles from './styles.scss'

class Index extends Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    containerId: PropTypes.string.isRequired,
  }

  createCategoryScrollLinks() {
    const { categories, containerId } = this.props
    return categories.map(category => {
      return (
        <ListItem key={category}>
          <Link label={category} to={category} containerId={containerId}/>
        </ListItem>
      )
    })
  }

  render() {
    return (
      <Flex column>
        <List>
          { this.createCategoryScrollLinks() }
        </List>
      </Flex>
    )
  }
}

export default CSSModules(styles, Index)
